import { Box } from "@mui/material";

import { useGetNavigationMenu } from "../../Shared/Navigation/navigationMenu/useGetNavigationMenu";
import {
  NavigationItem as NavigationItemParams,
  NavigationSection as NavigationSectionParams,
} from "../../Shared/Navigation/navigationMenu/types";
import { useAdminMenuPriviligesProviderContext } from "../../Shared/Navigation/priviligesProviders/AdminMenuPriviligesProvider";
import { useWorkerMenuPriviligesProviderContext } from "../../Shared/Navigation/priviligesProviders/WorkerMenuPriviligesProvider";
import { useWorkplaceMenuPriviligesProviderContext } from "../../Shared/Navigation/priviligesProviders/WorkplaceMenuPriviligesProvider";
import { usePendingExtraWorkedTimeRequestCount } from "../../Shared/Navigation/usePendingExtraWorkedTimeRequestCount";
import { useUnreadChannelCount } from "../../Shared/Navigation/useUnreadChannelCount";
import { NavigationMenuItemTablet } from "@src/appV2/redesign/AppLayout/Desktop/Tablet/Navigation/MenuItem";
import { NavigationMenuSectionTitleTablet } from "@src/appV2/redesign/AppLayout/Desktop/Tablet/Navigation/MenuSectionTitle";

export interface NavigationMenuItemsTabletProps {
  isAdmin: boolean;
  isWorkplace: boolean;
  isWorker: boolean;
}

function NavigationItem(params: NavigationItemParams) {
  const { iconType, isSelected, routeTo, onClick, badgeCount } = params;

  return (
    <NavigationMenuItemTablet
      iconType={iconType}
      isSelected={isSelected}
      routeTo={routeTo}
      onClick={onClick}
      badgeCount={badgeCount}
    />
  );
}

function NavigationSection(params: NavigationSectionParams) {
  const { label, items } = params;

  return (
    <Box paddingTop={3}>
      <NavigationMenuSectionTitleTablet>{label}</NavigationMenuSectionTitleTablet>
      {items.map((item) => (
        <NavigationItem key={item.label} {...item} />
      ))}
    </Box>
  );
}

export function NavigationMenuItemsTablet(props: NavigationMenuItemsTabletProps) {
  const { isAdmin, isWorker, isWorkplace } = props;

  const currentPath = location.pathname;
  const adminMenuPriviliges = useAdminMenuPriviligesProviderContext();
  const workplaceMenuPriviliges = useWorkplaceMenuPriviligesProviderContext();
  const workerMenuPriviliges = useWorkerMenuPriviligesProviderContext();
  const unreadChannelCount = useUnreadChannelCount();
  const pendingExtraWorkedTimeRequestCount = usePendingExtraWorkedTimeRequestCount();

  const navigationMenu = useGetNavigationMenu(
    isAdmin,
    adminMenuPriviliges,
    isWorker,
    workerMenuPriviliges,
    isWorkplace,
    workplaceMenuPriviliges,
    currentPath,
    { unreadChannelCount, pendingExtraWorkedTimeRequestCount }
  );

  return (
    <>
      {navigationMenu.items.map((item) =>
        "items" in item ? (
          <NavigationSection key={item.label} {...item} />
        ) : (
          <NavigationItem key={item.label} {...item} />
        )
      )}
    </>
  );
}
